export const AuctionInfoStyles = {
	wrapper: {
		display: 'flex',
		gap: '16px',

		'@media (max-width: 639.98px)': {
			padding: '16px 20px 0',
		},
	},
};
